// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { AdminMenuWalliconLogo, HamBurgerIcon } from "../components/icons/Icon";
// import styles from "./Menus.module.css";
// import { useAuth } from "../components/context/Auth";
// import useWindowWidth from "../components/updatedComponents/Hooks/WidthSize";
// import { useDispatch } from "react-redux";
// import { resetcampaignDashbord } from "../store/slices/campaign/CampaignDashbord";
// import { resetTemplatesFilter } from "../store/slices/campaign/TemplatesSlice";
// import { resetSearchDealerData } from "../store/slices/dealer/DealerSlice";
// import { resetProductFilter } from "../store/slices/product/ProductSlice";
// import { resetAllFilters } from "../store/slices/delivery/DeliverySlice";
// import { resetAllFilters as resetMangerFilters } from "../store/slices/managers/ManagersSlice";
// import { resetAllFilters as resetInvoicesFilters } from "../store/slices/invoices/InvoicesSlice";
// import { resetAppsFilter } from "../store/slices/apps/AppsSlice";
// import { resetItemSarch, resetProductSarch } from "../store/slices/inventory/InventorySlice";

// const AdminMenu = ({ onClick, isClosed, menuItems }) => {
//   const navigate = useNavigate();
//   const { designation, mode } = useAuth();
//   const { pathname } = useLocation();
//   const [hoveredPath, setHoveredPath] = useState(null);
//   const [hoveredIcon, setHovereIcon] = useState(null);
//   const width = useWindowWidth();
//   const [updatedMenuItems, setUpdatedMenuItems] = useState([]);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     console.log("menuItems", menuItems);
//     const updatedItems = [...menuItems];
//     if (designation && designation.length >= 1) {
//       updatedItems[0] = { ...updatedItems[0], label: "DASHBOARD" };
//     }
//     console.log("updatedItems", updatedItems);

//     setUpdatedMenuItems(updatedItems);
//   }, [designation, menuItems]);

//   const handleMenuClick = (path) => {
//     if (path !== "/dealers") {
//       dispatch(resetSearchDealerData());
//     }

//     if (path !== "/campaign") {
//       dispatch(resetcampaignDashbord());
//       dispatch(resetTemplatesFilter());
//     }

//     if (path !== "/products") {
//       dispatch(resetProductFilter());
//     }

//     if (path !== "/delivery") {
//       dispatch(resetAllFilters());
//     }

//     if (path !== "/managers") {
//       dispatch(resetMangerFilters());
//     }

//     if (path !== "/apps") {
//       dispatch(resetAppsFilter());
//     }

//     if (path !== "/invoices") {
//       dispatch(resetInvoicesFilters());
//     }

//     if (path !== "/inventory") {
//       dispatch(resetProductSarch());
//       dispatch(resetItemSarch());
//     }

//     navigate(path);
//   }

//   return (
//     <React.Fragment>
//       <div className={`${styles.admin_menu_logo} ${mode ? styles.admin_menu_logo_dark : {}}`}
//       >
//         {isClosed ? (
//           <div onClick={onClick} >
//             <HamBurgerIcon color={mode ? "#fff" : "#646B88"} />
//           </div>
//         ) : (
//           <div onClick={onClick}>
//             <AdminMenuWalliconLogo
//               backgroundColor={mode ? "#232529" : "#F5F6FA"}
//               textColor={mode ? "#FFFFFF" : "#231F20"}
//             />
//           </div>
//         )}
//       </div>
//       <div className={styles.menuItem_div_con}>
//         {updatedMenuItems.map(({ label, path, Icon }) => {
//           const getBaseRoute = (url) => {
//             const firstSlashIndex = url?.indexOf('/', 1);
//             return firstSlashIndex === -1 ? url : url?.slice(0, firstSlashIndex);
//           };

//           const basePathname = getBaseRoute(pathname);
//           const basePath = getBaseRoute(path);
//           return (
//             <div
//               key={path}
//               className={`${styles.menuItem_div} ${basePathname === basePath
//                 ? mode ? `${styles.active_div_Dark}` : `${styles.active_div}` : ""
//                 } ${isClosed ? styles.menuItem_div_toggled : ""}`}
//               onClick={() => handleMenuClick(path)}
//               onMouseEnter={() => {
//                 setHoveredPath(path);
//                 setHovereIcon(path);
//               }}
//               onMouseLeave={() => {
//                 setHoveredPath(null);
//                 setHovereIcon(null);
//               }}
//               style={{
//                 backgroundColor: basePathname === basePath
//                   ? mode ? "#232529" : "#f5f6fa"
//                   : mode ? hoveredPath === path ? "#232529" : "#2C2E33"
//                     : hoveredPath === path ? "#f5f6fa" : "#ffffff",
//               }}
//             >
//               <div>
//                 {width < 1250
//                   ? hoveredIcon === path && (
//                     <div
//                       className={styles.hoverPathname}
//                       style={{
//                         backgroundColor: mode ? "#000" : "#bebebe",
//                         color: mode ? "#fff" : "#000",
//                         display: "none",
//                       }}
//                     >
//                       <div>{label}</div>
//                     </div>
//                   )
//                   : null}
//                 <Icon
//                   css={styles.iconImage}
//                   color={mode ? "#ffffff" : "#646B88"}
//                 />
//               </div>
//               <span
//                 className={isClosed ? styles.hide_span : ""}
//                 style={mode ? { color: "#fff" } : { color: "#646B88" }}
//               >
//                 {label}
//               </span>
//             </div>
//           )
//         }

//         )}
//       </div>
//     </React.Fragment>
//   );
// };

// export default AdminMenu;

// ------------------------------- Working Menu First ----------------------

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  // AdminMenuWalliconLogo,
  // DefaultLogo,
  HamBurgerIcon,
} from "../components/icons/Icon";
import styles from "./Menus.module.css";
import { useAuth } from "../components/context/Auth";
import useWindowWidth from "../components/updatedComponents/Hooks/WidthSize";
import { useDispatch, useSelector } from "react-redux";
import { resetcampaignDashbord } from "../store/slices/campaign/CampaignDashbord";
import { resetTemplatesFilter } from "../store/slices/campaign/TemplatesSlice";
import { resetSearchDealerData } from "../store/slices/dealer/DealerSlice";
import { resetProductFilter } from "../store/slices/product/ProductSlice";
import { resetAllFilters } from "../store/slices/delivery/DeliverySlice";
import { resetAllFilters as resetMangerFilters } from "../store/slices/managers/ManagersSlice";
import { resetAllFilters as resetInvoicesFilters } from "../store/slices/invoices/InvoicesSlice";
import { resetAppsFilter } from "../store/slices/apps/AppsSlice";
import {
  resetItemSarch,
  resetProductSarch,
} from "../store/slices/inventory/InventorySlice";
import { IconMap } from "../exports";
import { Drag } from "../components/icons/Icon2";
import { useBranding } from "../components/context/BrandingContext";

const AdminMenu = ({ onClick, isClosed, menuItems }) => {
  const navigate = useNavigate();
  const { designation, mode } = useAuth();
  const { dragMode } = useSelector((item) => item.layout);
  const { pathname } = useLocation();
  const [hoveredPath, setHoveredPath] = useState(null);
  const [hoveredIcon, setHovereIcon] = useState(null);
  const width = useWindowWidth();
  const [updatedMenuItems, setUpdatedMenuItems] = useState([]);
  const dispatch = useDispatch();
  const { branding } = useBranding();
  const [draggedIndex, setDraggedIndex] = useState(null);

  useEffect(() => {
    const storedMenu = localStorage.getItem("updatedMenuItems");
    if (storedMenu) {
      const parsed = JSON.parse(storedMenu).map((item) => ({
        ...item,
        Icon: IconMap[item.Icon] || null,
      }));
      setUpdatedMenuItems(parsed);
    } else {
      const updatedItems = [...menuItems];
      if (designation && designation.length >= 1) {
        updatedItems[0] = { ...updatedItems[0], label: "DASHBOARD" };
      }
      setUpdatedMenuItems(updatedItems);
    }
  }, [designation, menuItems]);

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDrop = (dropIndex) => {
    if (draggedIndex === null) return;
    if (designation.includes("superadmin") || designation.length === 1) {
      console.log("Drag & Drop feature disabled for this user");
      setDraggedIndex(null);
      return;
    }
    if (dropIndex === 0 && draggedIndex !== 0) {
      const items = [...updatedMenuItems];
      const droppedItem = { ...items[draggedIndex] };
      const oldDashboard = { ...items[0] };
      items[0] = { ...droppedItem, label: "DASHBOARD" };
      const originalOldDashboard = menuItems.find(
        (m) => m.path === oldDashboard.path,
      );
      items[draggedIndex] = originalOldDashboard
        ? { ...originalOldDashboard }
        : { ...oldDashboard };
      localStorage.setItem("dashboardRoute", droppedItem.path);
      localStorage.setItem(
        "updatedMenuItems",
        JSON.stringify(
          items.map((item) => ({
            ...item,
            Icon: item.Icon?.name || item.IconName || null,
          })),
        ),
      );
      setUpdatedMenuItems(items);
    }
    setDraggedIndex(null);
  };

  const handleMenuClick = (path) => {
    if (dragMode) return;
    if (path !== "/dealers") dispatch(resetSearchDealerData());
    if (path !== "/campaign") {
      dispatch(resetcampaignDashbord());
      dispatch(resetTemplatesFilter());
    }
    if (path !== "/products") dispatch(resetProductFilter());
    if (path !== "/delivery") dispatch(resetAllFilters());
    if (path !== "/managers") dispatch(resetMangerFilters());
    if (path !== "/apps") dispatch(resetAppsFilter());
    if (path !== "/invoices") dispatch(resetInvoicesFilters());
    if (path !== "/inventory") {
      dispatch(resetProductSarch());
      dispatch(resetItemSarch());
    }
    navigate(path);
  };

  return (
    <React.Fragment>
      <div
        className={`${styles.admin_menu_logo} ${mode ? styles.admin_menu_logo_dark : {}}`}
      >
        {isClosed ? (
          <div onClick={onClick}>
            <HamBurgerIcon color={mode ? "#fff" : "#646B88"} />
          </div>
        ) : (
          // <div onClick={onClick} className={styles.nm_photo}>
          //   <AdminMenuWalliconLogo
          //     backgroundColor={mode ? "#232529" : "#F5F6FA"}
          //     textColor={mode ? "#FFFFFF" : "#231F20"}
          //   />
          //   </div>
          <div
            onClick={onClick}
            className={`${styles.logo_img} ${mode ? styles.dark : ""}`}
          >
            <div onClick={onClick} className={styles.logo_img}>
              {branding.favicon && (
                <img
                  src={branding.favicon}
                  alt="Company Logo"
                  style={{
                    filter: !mode ? "brightness(0) saturate(100%)" : "none",
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <div className={styles.menuItem_div_con}>
        {updatedMenuItems.map(({ label, path, Icon, IconName }, index) => {
          const FinalIcon = Icon || IconMap[IconName];
          const getBaseRoute = (url) => {
            const firstSlashIndex = url?.indexOf("/", 1);
            return firstSlashIndex === -1
              ? url
              : url?.slice(0, firstSlashIndex);
          };
          const basePathname = getBaseRoute(pathname);
          const basePath = getBaseRoute(path);
          return (
            <div
              key={path}
              className={`${styles.menuItem_div} ${
                basePathname === basePath
                  ? mode
                    ? `${styles.active_div_Dark}`
                    : `${styles.active_div}`
                  : ""
              } ${isClosed ? styles.menuItem_div_toggled : ""}`}
              onClick={() => handleMenuClick(path)}
              onMouseEnter={() => {
                setHoveredPath(path);
                setHovereIcon(path);
              }}
              onMouseLeave={() => {
                setHoveredPath(null);
                setHovereIcon(null);
              }}
              draggable={dragMode}
              onDragStart={() => handleDragStart(index)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => handleDrop(index)}
              style={{
                backgroundColor:
                  basePathname === basePath
                    ? mode
                      ? "#232529"
                      : "#f5f6fa"
                    : mode
                      ? hoveredPath === path
                        ? "#232529"
                        : "#2C2E33"
                      : hoveredPath === path
                        ? "#f5f6fa"
                        : "#ffffff",
              }}
            >
              {/* Drag Handle - only show when dragMode is true */}
              {dragMode && (
                <div className={styles.dragHandle}>
                  <Drag color={mode ? "#fff" : "#000"} />
                </div>
              )}

              <div>
                {width < 1250
                  ? hoveredIcon === path && (
                      <div
                        className={styles.hoverPathname}
                        style={{
                          backgroundColor: mode ? "#000" : "#bebebe",
                          color: mode ? "#fff" : "#000",
                          display: "none",
                        }}
                      >
                        <div>{label}</div>
                      </div>
                    )
                  : null}
                <FinalIcon
                  css={styles.iconImage}
                  color={mode ? "#ffffff" : "#646B88"}
                />
              </div>
              <span
                className={isClosed ? styles.hide_span : ""}
                style={mode ? { color: "#fff" } : { color: "#646B88" }}
              >
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default AdminMenu;

// ---------------------------- For Dropdown Menu ---------------------------

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { HamBurgerIcon } from "../components/icons/Icon";
// import { Drag } from "../components/icons/Icon2";
// import styles from "./Menus.module.css";
// import { useAuth } from "../components/context/Auth";
// import useWindowWidth from "../components/updatedComponents/Hooks/WidthSize";
// import { useDispatch, useSelector } from "react-redux";
// import { resetcampaignDashbord } from "../store/slices/campaign/CampaignDashbord";
// import { resetTemplatesFilter } from "../store/slices/campaign/TemplatesSlice";
// import { resetSearchDealerData } from "../store/slices/dealer/DealerSlice";
// import { resetProductFilter } from "../store/slices/product/ProductSlice";
// import { resetAllFilters } from "../store/slices/delivery/DeliverySlice";
// import { resetAllFilters as resetMangerFilters } from "../store/slices/managers/ManagersSlice";
// import { resetAllFilters as resetInvoicesFilters } from "../store/slices/invoices/InvoicesSlice";
// import { resetAppsFilter } from "../store/slices/apps/AppsSlice";
// import {
//   resetItemSarch,
//   resetProductSarch,
// } from "../store/slices/inventory/InventorySlice";
// import { IconMap } from "../exports";
// import { useBranding } from "../components/context/BrandingContext";

// const ChevronIcon = ({ open, color }) => (
//   <svg
//     width="12"
//     height="12"
//     viewBox="0 0 12 12"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     style={{
//       transition: "transform 0.2s ease",
//       transform: open ? "rotate(180deg)" : "rotate(0deg)",
//       flexShrink: 0,
//     }}
//   >
//     <path
//       d="M2 4L6 8L10 4"
//       stroke={color || "#646B88"}
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const STANDALONE_PATHS = ["/dashboard", "/ai", "/whatsappchats", "/settings"];

// const MENU_GROUPS = [
//   {
//     label: "SALES",
//     iconKey: "SideBarOrdersIcon",
//     paths: ["/marketing", "/dealers", "/orders", "/complaints"],
//   },
//   { label: "PRODUCTION", iconKey: "SideBarInventoryIcon", paths: [] },
//   {
//     label: "STOCK",
//     iconKey: "SideBarProductIcon",
//     paths: ["/products", "/inventory", "/warehouses", "/deleteoredit"],
//   },
//   {
//     label: "DISPATCH",
//     iconKey: "SideBarDispatchIcon",
//     paths: ["/packingorder", "/dispatch", "/invoices", "/delivery"],
//   },
//   {
//     label: "ACCOUNTS",
//     iconKey: "SideBarReceiptIcon",
//     paths: ["/recipts", "/transactions", "/refunds"],
//   },
//   {
//     label: "MARKETING",
//     iconKey: "SideBarMarketingIcon",
//     paths: ["/campaign", "/greetings", "/createnotification"],
//   },
//   {
//     label: "TEAM",
//     iconKey: "SideBarManagerIcon",
//     paths: ["/managers", "/jobs", "/applicants"],
//   },
//   {
//     label: "UTILITIES",
//     iconKey: "AppsIcon",
//     paths: ["/apps", "/printers", "/energy"],
//   },
// ];

// const getBaseRoute = (url) => {
//   if (!url) return url;
//   const i = url.indexOf("/", 1);
//   return i === -1 ? url : url.slice(0, i);
// };

// // ─── Single shared row style — used by EVERY row: standalone, group header, sub-item
// // This is the ONE source of truth for padding/height so nothing shifts left
// const ROW = {
//   width: "100%",
//   boxSizing: "border-box",
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   gap: "10px",
//   padding: "10px 14px", // identical for all rows
//   fontSize: "12px",
//   fontWeight: 500,
//   lineHeight: "18px",
//   cursor: "pointer",
//   transition: "background-color 0.15s",
//   userSelect: "none",
// };

// // Sub-items get extra left indent on top of the base padding
// const SUB_ROW = {
//   ...ROW,
//   padding: "9px 14px 9px 38px",
//   fontSize: "11px",
// };

// const AdminMenu = ({ onClick, isClosed, menuItems }) => {
//   const navigate = useNavigate();
//   const { designation, mode } = useAuth();
//   const { dragMode } = useSelector((s) => s.layout);
//   const { pathname } = useLocation();
//   const dispatch = useDispatch();
//   const { branding } = useBranding();

//   const [updatedMenuItems, setUpdatedMenuItems] = useState([]);
//   const [openGroup, setOpenGroup] = useState(null);
//   const [hoveredPath, setHoveredPath] = useState(null);
//   const [hoveredGroup, setHoveredGroup] = useState(null);
//   const [draggedIndex, setDraggedIndex] = useState(null);

//   // Auto-open group that owns the active route
//   useEffect(() => {
//     const base = getBaseRoute(pathname);
//     const active = MENU_GROUPS.find((g) => g.paths.includes(base));
//     // If navigating to a standalone page → close any open group
//     setOpenGroup(active ? active.label : null);
//   }, [pathname]);

//   useEffect(() => {
//     const storedMenu = localStorage.getItem("updatedMenuItems");
//     if (storedMenu) {
//       try {
//         const parsed = JSON.parse(storedMenu).map((item) => ({
//           ...item,
//           Icon: IconMap[item.Icon] || null,
//         }));
//         setUpdatedMenuItems(parsed);
//         return;
//       } catch (_) {}
//     }
//     const items = [...menuItems];
//     if (designation?.length >= 1)
//       items[0] = { ...items[0], label: "DASHBOARD" };
//     setUpdatedMenuItems(items);
//   }, [designation, menuItems]);

//   const handleDragStart = (index) => setDraggedIndex(index);
//   const handleDrop = (dropIndex) => {
//     if (draggedIndex === null) return;
//     if (designation.includes("superadmin") || designation.length === 1) {
//       setDraggedIndex(null);
//       return;
//     }
//     if (dropIndex === 0 && draggedIndex !== 0) {
//       const items = [...updatedMenuItems];
//       const droppedItem = { ...items[draggedIndex] };
//       const oldDashboard = { ...items[0] };
//       items[0] = { ...droppedItem, label: "DASHBOARD" };
//       const orig = menuItems.find((m) => m.path === oldDashboard.path);
//       items[draggedIndex] = orig ? { ...orig } : { ...oldDashboard };
//       localStorage.setItem("dashboardRoute", droppedItem.path);
//       localStorage.setItem(
//         "updatedMenuItems",
//         JSON.stringify(
//           items.map((item) => ({
//             ...item,
//             Icon: item.Icon?.name || item.IconName || null,
//           })),
//         ),
//       );
//       setUpdatedMenuItems(items);
//     }
//     setDraggedIndex(null);
//   };

//   const handleMenuClick = (path) => {
//     if (dragMode) return;
//     // Close open group when navigating to a standalone page
//     const base = getBaseRoute(path);
//     const belongsToGroup = MENU_GROUPS.some((g) => g.paths.includes(base));
//     if (!belongsToGroup) setOpenGroup(null);

//     if (path !== "/dealers") dispatch(resetSearchDealerData());
//     if (path !== "/campaign") {
//       dispatch(resetcampaignDashbord());
//       dispatch(resetTemplatesFilter());
//     }
//     if (path !== "/products") dispatch(resetProductFilter());
//     if (path !== "/delivery") dispatch(resetAllFilters());
//     if (path !== "/managers") dispatch(resetMangerFilters());
//     if (path !== "/apps") dispatch(resetAppsFilter());
//     if (path !== "/invoices") dispatch(resetInvoicesFilters());
//     if (path !== "/inventory") {
//       dispatch(resetProductSarch());
//       dispatch(resetItemSarch());
//     }
//     navigate(path);
//   };

//   const toggleGroup = (label) =>
//     setOpenGroup((prev) => (prev === label ? null : label));

//   const standaloneItems = updatedMenuItems.filter((item) =>
//     STANDALONE_PATHS.includes(getBaseRoute(item.path)),
//   );
//   const getGroupItems = (groupPaths) =>
//     updatedMenuItems.filter((item) =>
//       groupPaths.includes(getBaseRoute(item.path)),
//     );

//   // ── Theme palette
//   const C = mode
//     ? {
//         itemBg: "#2C2E33",
//         itemHover: "#35383f",
//         itemActive: "#232529",
//         groupOpenBg: "#232529",
//         subAreaBg: "#25272c",
//         subHover: "#2e3138",
//         // subActive: "#2e3040",
//         subActive: "#35383f",
//         text: "#9ea3b0",
//         textActive: "#ffffff",
//         textGroupOpen: "#ffffff",
//       }
//     : {
//         itemBg: "#ffffff",
//         itemHover: "#f5f6fa",
//         itemActive: "#eef0f8",
//         groupOpenBg: "#eef0f8",
//         subAreaBg: "#f5f6fa",
//         subHover: "#eaecf5",
//         subActive: "#e2e5f5",
//         text: "#646B88",
//         textActive: "#1a1a2e",
//         textGroupOpen: "#1a1a2e",
//       };

//   // ── Standalone row (DASHBOARD, ASK AI, CHAT, SETTINGS)
//   const renderStandaloneItem = (item, index) => {
//     const { label, path, Icon, IconName } = item;
//     const FinalIcon = Icon || IconMap[IconName];
//     const isActive = getBaseRoute(pathname) === getBaseRoute(path);
//     const isHovered = hoveredPath === path;

//     const rowStyle = isClosed
//       ? {
//           ...ROW,
//           flexDirection: "column",
//           justifyContent: "center",
//           padding: "10px 4px",
//           fontSize: "10px",
//           gap: "2px",
//           backgroundColor: isActive
//             ? C.itemActive
//             : isHovered
//               ? C.itemHover
//               : C.itemBg,
//         }
//       : {
//           ...ROW,
//           backgroundColor: isActive
//             ? C.itemActive
//             : isHovered
//               ? C.itemHover
//               : C.itemBg,
//         };

//     return (
//       <div
//         key={path}
//         style={rowStyle}
//         onClick={() => handleMenuClick(path)}
//         onMouseEnter={() => setHoveredPath(path)}
//         onMouseLeave={() => setHoveredPath(null)}
//         draggable={dragMode}
//         onDragStart={() => handleDragStart(index)}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={() => handleDrop(index)}
//       >
//         {dragMode && (
//           <div className={styles.dragHandle}>
//             <Drag color={mode ? "#fff" : "#000"} />
//           </div>
//         )}
//         {FinalIcon && (
//           <FinalIcon
//             css={styles.iconImage}
//             color={isActive ? C.textActive : C.text}
//           />
//         )}
//         {!isClosed && (
//           <span
//             style={{
//               color: isActive ? C.textActive : C.text,
//               fontWeight: isActive ? 600 : 500,
//               flex: 1,
//             }}
//           >
//             {label}
//           </span>
//         )}
//       </div>
//     );
//   };

//   // ── Sub-item row
//   const renderSubItem = (item, index) => {
//     const { label, path, Icon, IconName } = item;
//     const FinalIcon = Icon || IconMap[IconName];
//     const isActive = getBaseRoute(pathname) === getBaseRoute(path);
//     const isHovered = hoveredPath === path;

//     return (
//       <div
//         key={path}
//         style={{
//           ...SUB_ROW,
//           backgroundColor: isActive
//             ? C.subActive
//             : isHovered
//               ? C.subHover
//               : C.subAreaBg,
//         }}
//         onClick={() => handleMenuClick(path)}
//         onMouseEnter={() => setHoveredPath(path)}
//         onMouseLeave={() => setHoveredPath(null)}
//         draggable={dragMode}
//         onDragStart={() => handleDragStart(index)}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={() => handleDrop(index)}
//       >
//         {dragMode && (
//           <div className={styles.dragHandle}>
//             <Drag color={mode ? "#fff" : "#000"} />
//           </div>
//         )}
//         {FinalIcon && (
//           <FinalIcon
//             css={styles.iconImage}
//             color={isActive ? C.textActive : C.text}
//           />
//         )}
//         <span
//           style={{
//             color: isActive ? C.textActive : C.text,
//             fontWeight: isActive ? 600 : 400,
//           }}
//         >
//           {label}
//         </span>
//       </div>
//     );
//   };

//   return (
//     <React.Fragment>
//       {/* Logo */}
//       <div
//         className={`${styles.admin_menu_logo} ${mode ? styles.admin_menu_logo_dark : ""}`}
//       >
//         {isClosed ? (
//           <div onClick={onClick}>
//             <HamBurgerIcon color={mode ? "#fff" : "#646B88"} />
//           </div>
//         ) : (
//           <div
//             onClick={onClick}
//             className={`${styles.logo_img} ${mode ? styles.dark : ""}`}
//           >
//             {branding.favicon && (
//               <img
//                 src={branding.favicon}
//                 alt="Company Logo"
//                 style={{
//                   filter: !mode ? "brightness(0) saturate(100%)" : "none",
//                 }}
//               />
//             )}
//           </div>
//         )}
//       </div>

//       {/* Menu list — no gap, no padding, stretch full width */}
//       <div
//         className={styles.menuItem_div_con}
//         style={{ gap: 0, padding: "4px 0", alignItems: "stretch" }}
//       >
//         {/* ── Top standalones: DASHBOARD, ASK AI */}
//         {standaloneItems
//           .filter((item) =>
//             ["/dashboard", "/ai"].includes(getBaseRoute(item.path)),
//           )
//           .map((item, i) => renderStandaloneItem(item, i))}

//         {/* ── Groups */}
//         {MENU_GROUPS.map((group) => {
//           const groupItems = getGroupItems(group.paths);
//           if (groupItems.length === 0 && group.paths.length > 0) return null;

//           const isOpen = openGroup === group.label;
//           const isGroupActive = groupItems.some(
//             (item) => getBaseRoute(pathname) === getBaseRoute(item.path),
//           );
//           const GroupIcon = IconMap[group.iconKey];
//           const isHovered = hoveredGroup === group.label;

//           const headerStyle = isClosed
//             ? {
//                 ...ROW,
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 padding: "10px 4px",
//                 fontSize: "10px",
//                 gap: "2px",
//                 cursor: "default",
//                 backgroundColor: isOpen
//                   ? C.groupOpenBg
//                   : isHovered
//                     ? C.itemHover
//                     : C.itemBg,
//               }
//             : {
//                 ...ROW,
//                 backgroundColor: isOpen
//                   ? C.groupOpenBg
//                   : isHovered
//                     ? C.itemHover
//                     : C.itemBg,
//               };

//           return (
//             <div key={group.label} style={{ width: "100%" }}>
//               {/* Group header */}
//               <div
//                 style={headerStyle}
//                 onClick={() => !isClosed && toggleGroup(group.label)}
//                 onMouseEnter={() => setHoveredGroup(group.label)}
//                 onMouseLeave={() => setHoveredGroup(null)}
//               >
//                 {GroupIcon && (
//                   <GroupIcon
//                     css={styles.iconImage}
//                     color={isOpen || isGroupActive ? C.textGroupOpen : C.text}
//                   />
//                 )}
//                 {!isClosed && (
//                   <>
//                     <span
//                       style={{
//                         flex: 1,
//                         color: isOpen ? C.textGroupOpen : C.text,
//                         fontWeight: isOpen ? 600 : 500,
//                       }}
//                     >
//                       {group.label}
//                     </span>
//                     <ChevronIcon
//                       open={isOpen}
//                       color={isOpen ? C.textGroupOpen : C.text}
//                     />
//                   </>
//                 )}
//               </div>

//               {/* Sub-items with smooth slide */}
//               {!isClosed && (
//                 <div
//                   style={{
//                     width: "100%",
//                     overflow: "hidden",
//                     maxHeight: isOpen ? `${groupItems.length * 44}px` : "0px",
//                     transition: "max-height 0.22s ease",
//                     backgroundColor: C.subAreaBg,
//                   }}
//                 >
//                   {groupItems.map((item, i) => renderSubItem(item, i))}
//                 </div>
//               )}
//             </div>
//           );
//         })}

//         {/* ── Bottom standalones: CHAT, SETTINGS */}
//         {standaloneItems
//           .filter((item) =>
//             ["/whatsappchats", "/settings"].includes(getBaseRoute(item.path)),
//           )
//           .map((item, i) => renderStandaloneItem(item, i))}
//       </div>
//     </React.Fragment>
//   );
// };

// export default AdminMenu;

// ----------------------------------------------------

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { HamBurgerIcon } from "../components/icons/Icon";
// import { Drag } from "../components/icons/Icon2";
// import styles from "./Menus.module.css";
// import { useAuth } from "../components/context/Auth";
// import useWindowWidth from "../components/updatedComponents/Hooks/WidthSize";
// import { useDispatch, useSelector } from "react-redux";
// import { resetcampaignDashbord } from "../store/slices/campaign/CampaignDashbord";
// import { resetTemplatesFilter } from "../store/slices/campaign/TemplatesSlice";
// import { resetSearchDealerData } from "../store/slices/dealer/DealerSlice";
// import { resetProductFilter } from "../store/slices/product/ProductSlice";
// import { resetAllFilters } from "../store/slices/delivery/DeliverySlice";
// import { resetAllFilters as resetMangerFilters } from "../store/slices/managers/ManagersSlice";
// import { resetAllFilters as resetInvoicesFilters } from "../store/slices/invoices/InvoicesSlice";
// import { resetAppsFilter } from "../store/slices/apps/AppsSlice";
// import {
//   resetItemSarch,
//   resetProductSarch,
// } from "../store/slices/inventory/InventorySlice";
// import { IconMap } from "../exports";
// import { useBranding } from "../components/context/BrandingContext";

// const ChevronIcon = ({ open, color }) => (
//   <svg
//     width="12"
//     height="12"
//     viewBox="0 0 12 12"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     style={{
//       transition: "transform 0.2s ease",
//       transform: open ? "rotate(180deg)" : "rotate(0deg)",
//       flexShrink: 0,
//     }}
//   >
//     <path
//       d="M2 4L6 8L10 4"
//       stroke={color || "#646B88"}
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const STANDALONE_PATHS = ["/dashboard", "/ai", "/whatsappchats", "/settings"];

// const MENU_GROUPS = [
//   {
//     label: "SALES",
//     iconKey: "SideBarOrdersIcon",
//     paths: ["/marketing", "/dealers", "/orders", "/complaints"],
//   },
//   // { label: "PRODUCTION", iconKey: "SideBarInventoryIcon", paths: [] },
//   {
//     label: "STOCK",
//     iconKey: "SideBarProductIcon",
//     paths: ["/products", "/inventory", "/warehouses", "/deleteoredit"],
//   },
//   {
//     label: "DISPATCH",
//     iconKey: "SideBarDispatchIcon",
//     paths: ["/packingorder", "/dispatch", "/invoices", "/delivery"],
//   },
//   {
//     label: "ACCOUNTS",
//     iconKey: "SideBarReceiptIcon",
//     paths: ["/recipts", "/transactions", "/refunds"],
//   },
//   {
//     label: "MARKETING",
//     iconKey: "SideBarMarketingIcon",
//     paths: ["/campaign", "/greetings", "/createnotification"],
//   },
//   {
//     label: "TEAM",
//     iconKey: "SideBarManagerIcon",
//     paths: ["/managers", "/jobs", "/applicants"],
//   },
//   {
//     label: "UTILITIES",
//     iconKey: "AppsIcon",
//     paths: ["/apps", "/printers", "/energy"],
//   },
// ];

// const getBaseRoute = (url) => {
//   if (!url) return url;
//   const i = url.indexOf("/", 1);
//   return i === -1 ? url : url.slice(0, i);
// };

// // ─── Single shared row style — used by EVERY row: standalone, group header, sub-item
// // This is the ONE source of truth for padding/height so nothing shifts left
// const ROW = {
//   width: "100%",
//   boxSizing: "border-box",
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   gap: "10px",
//   padding: "10px 14px", // identical for all rows
//   fontSize: "12px",
//   fontWeight: 500,
//   lineHeight: "18px",
//   cursor: "pointer",
//   transition: "background-color 0.15s",
//   userSelect: "none",
// };

// const AdminMenu = ({ onClick, isClosed, menuItems }) => {
//   const navigate = useNavigate();
//   const { designation, mode } = useAuth();
//   const { dragMode } = useSelector((s) => s.layout);
//   const { pathname } = useLocation();
//   const dispatch = useDispatch();
//   const { branding } = useBranding();

//   const [updatedMenuItems, setUpdatedMenuItems] = useState([]);
//   const [openGroup, setOpenGroup] = useState(null);
//   const [hoveredPath, setHoveredPath] = useState(null);
//   const [hoveredGroup, setHoveredGroup] = useState(null);
//   const [draggedIndex, setDraggedIndex] = useState(null);

//   // Auto-open group that owns the active route
//   useEffect(() => {
//     const base = getBaseRoute(pathname);
//     const active = MENU_GROUPS.find((g) => g.paths.includes(base));
//     // If navigating to a standalone page → close any open group
//     setOpenGroup(active ? active.label : null);
//   }, [pathname]);

//   useEffect(() => {
//     // Per-designation key so different roles never share saved menu order
//     const storageKey = `updatedMenuItems_${designation?.[0] || "default"}`;
//     const storedMenu = localStorage.getItem(storageKey);
//     if (storedMenu) {
//       try {
//         const parsed = JSON.parse(storedMenu).map((item) => ({
//           ...item,
//           Icon: IconMap[item.Icon] || null,
//         }));
//         setUpdatedMenuItems(parsed);
//         return;
//       } catch (_) {}
//     }
//     // Do NOT blindly relabel items[0] as "DASHBOARD".
//     // For superadmin, items[0] is already /dashboard with label DASHBOARD.
//     // For managers, items[0] is a grouped route (e.g. /dealers) — renaming it
//     // "DASHBOARD" causes it to appear inside the SALES group header wrongly.
//     setUpdatedMenuItems([...menuItems]);
//   }, [designation, menuItems]);

//   const handleDragStart = (index) => setDraggedIndex(index);
//   const handleDrop = (dropIndex) => {
//     if (draggedIndex === null) return;
//     if (designation.includes("superadmin") || designation.length === 1) {
//       setDraggedIndex(null);
//       return;
//     }
//     if (dropIndex === 0 && draggedIndex !== 0) {
//       const items = [...updatedMenuItems];
//       const droppedItem = { ...items[draggedIndex] };
//       const oldDashboard = { ...items[0] };
//       items[0] = { ...droppedItem, label: "DASHBOARD" };
//       const orig = menuItems.find((m) => m.path === oldDashboard.path);
//       items[draggedIndex] = orig ? { ...orig } : { ...oldDashboard };
//       const storageKey = `updatedMenuItems_${designation?.[0] || "default"}`;
//       localStorage.setItem("dashboardRoute", droppedItem.path);
//       localStorage.setItem(
//         storageKey,
//         JSON.stringify(
//           items.map((item) => ({
//             ...item,
//             Icon: item.Icon?.name || item.IconName || null,
//           })),
//         ),
//       );
//       setUpdatedMenuItems(items);
//     }
//     setDraggedIndex(null);
//   };

//   const handleMenuClick = (path) => {
//     if (dragMode) return;
//     // Close open group when navigating to a standalone page
//     const base = getBaseRoute(path);
//     const belongsToGroup = MENU_GROUPS.some((g) => g.paths.includes(base));
//     if (!belongsToGroup) setOpenGroup(null);

//     if (path !== "/dealers") dispatch(resetSearchDealerData());
//     if (path !== "/campaign") {
//       dispatch(resetcampaignDashbord());
//       dispatch(resetTemplatesFilter());
//     }
//     if (path !== "/products") dispatch(resetProductFilter());
//     if (path !== "/delivery") dispatch(resetAllFilters());
//     if (path !== "/managers") dispatch(resetMangerFilters());
//     if (path !== "/apps") dispatch(resetAppsFilter());
//     if (path !== "/invoices") dispatch(resetInvoicesFilters());
//     if (path !== "/inventory") {
//       dispatch(resetProductSarch());
//       dispatch(resetItemSarch());
//     }
//     navigate(path);
//   };

//   const toggleGroup = (label) =>
//     setOpenGroup((prev) => (prev === label ? null : label));

//   const standaloneItems = updatedMenuItems.filter((item) =>
//     STANDALONE_PATHS.includes(getBaseRoute(item.path)),
//   );
//   const getGroupItems = (groupPaths) =>
//     updatedMenuItems.filter((item) =>
//       groupPaths.includes(getBaseRoute(item.path)),
//     );

//   // ── Theme palette
//   const C = mode
//     ? {
//         itemBg: "#2C2E33",
//         itemHover: "#35383f",
//         itemActive: "#232529",
//         groupOpenBg: "#232529",
//         subAreaBg: "#25272c",
//         subHover: "#2e3138",
//         subActive: "#2e3040",
//         text: "#9ea3b0",
//         textActive: "#ffffff",
//         textGroupOpen: "#ffffff",
//       }
//     : {
//         itemBg: "#ffffff",
//         itemHover: "#f5f6fa",
//         itemActive: "#eef0f8",
//         // itemActive: "#D9DCE5",
//         groupOpenBg: "#eef0f8",
//         // groupOpenBg: "#D9DCE5",
//         subAreaBg: "#f5f6fa",
//         subHover: "#eaecf5",
//         subActive: "#e2e5f5",
//         // subActive: "#d6daf1",

//         text: "#646B88",
//         textActive: "#1a1a2e",
//         textGroupOpen: "#1a1a2e",
//       };

//   // ── Standalone row (DASHBOARD, ASK AI, CHAT, SETTINGS)
//   const renderStandaloneItem = (item, index) => {
//     const { label, path, Icon, IconName } = item;
//     const FinalIcon = Icon || IconMap[IconName];
//     const isActive = getBaseRoute(pathname) === getBaseRoute(path);
//     const isHovered = hoveredPath === path;

//     const rowStyle = isClosed
//       ? {
//           ...ROW,
//           flexDirection: "column",
//           justifyContent: "center",
//           padding: "10px 4px",
//           fontSize: "10px",
//           gap: "2px",
//           backgroundColor: isActive
//             ? C.itemActive
//             : isHovered
//               ? C.itemHover
//               : C.itemBg,
//         }
//       : {
//           ...ROW,
//           backgroundColor: isActive
//             ? C.itemActive
//             : isHovered
//               ? C.itemHover
//               : C.itemBg,
//         };

//     return (
//       <div
//         key={path}
//         style={rowStyle}
//         onClick={() => handleMenuClick(path)}
//         onMouseEnter={() => setHoveredPath(path)}
//         onMouseLeave={() => setHoveredPath(null)}
//         draggable={dragMode}
//         onDragStart={() => handleDragStart(index)}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={() => handleDrop(index)}
//       >
//         {dragMode && (
//           <div className={styles.dragHandle}>
//             <Drag color={mode ? "#fff" : "#000"} />
//           </div>
//         )}
//         {FinalIcon && (
//           <FinalIcon
//             css={styles.iconImage}
//             color={isActive ? C.textActive : C.text}
//           />
//         )}
//         {!isClosed && (
//           <span
//             style={{
//               color: isActive ? C.textActive : C.text,
//               fontWeight: isActive ? 600 : 500,
//               flex: 1,
//             }}
//           >
//             {label}
//           </span>
//         )}
//       </div>
//     );
//   };

//   // ── Sub-item row with tree connector lines
//   const renderSubItem = (item, index, isLast) => {
//     const { label, path, Icon, IconName } = item;
//     const FinalIcon = Icon || IconMap[IconName];
//     const isActive = getBaseRoute(pathname) === getBaseRoute(path);
//     const isHovered = hoveredPath === path;

//     const lineColor = mode ? "#3e4150" : "#d0d3e8";
//     const dotColor = isActive ? "#5b6af0" : mode ? "#555870" : "#b0b4d0";

//     return (
//       <div
//         key={path}
//         style={{
//           width: "100%",
//           boxSizing: "border-box",
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "center",
//           backgroundColor: isActive
//             ? C.subActive
//             : isHovered
//               ? C.subHover
//               : C.subAreaBg,
//           cursor: "pointer",
//           transition: "background-color 0.15s",
//           position: "relative",
//         }}
//         onClick={() => handleMenuClick(path)}
//         onMouseEnter={() => setHoveredPath(path)}
//         onMouseLeave={() => setHoveredPath(null)}
//         draggable={dragMode}
//         onDragStart={() => handleDragStart(index)}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={() => handleDrop(index)}
//       >
//         {dragMode && (
//           <div className={styles.dragHandle}>
//             <Drag color={mode ? "#fff" : "#000"} />
//           </div>
//         )}

//         {/* Tree line structure */}
//         <div
//           style={{
//             position: "relative",
//             width: "38px",
//             flexShrink: 0,
//             alignSelf: "stretch",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "flex-end",
//           }}
//         >
//           {/* Vertical line — full height but cut at bottom for last item */}
//           <div
//             style={{
//               position: "absolute",
//               left: "18px",
//               top: 0,
//               bottom: isLast ? "50%" : 0,
//               width: "1.5px",
//               backgroundColor: lineColor,
//             }}
//           />
//           {/* Horizontal branch line */}
//           <div
//             style={{
//               position: "absolute",
//               left: "18px",
//               top: "50%",
//               width: "12px",
//               height: "1.5px",
//               backgroundColor: lineColor,
//             }}
//           />
//           {/* Dot at junction */}
//           <div
//             style={{
//               position: "absolute",
//               left: "25px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               width: "6px",
//               height: "6px",
//               borderRadius: "50%",
//               backgroundColor: dotColor,
//               flexShrink: 0,
//               zIndex: 1,
//             }}
//           />
//         </div>

//         {/* Icon + label */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//             padding: "9px 10px 9px 2px",
//             flex: 1,
//             minWidth: 0,
//           }}
//         >
//           {FinalIcon && (
//             <FinalIcon
//               css={styles.iconImage}
//               color={isActive ? C.textActive : C.text}
//             />
//           )}
//           <span
//             style={{
//               color: isActive ? C.textActive : C.text,
//               fontWeight: isActive ? 600 : 400,
//               fontSize: "11px",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             }}
//           >
//             {label}
//           </span>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <React.Fragment>
//       {/* Logo */}
//       <div
//         className={`${styles.admin_menu_logo} ${mode ? styles.admin_menu_logo_dark : ""}`}
//       >
//         {isClosed ? (
//           <div onClick={onClick}>
//             <HamBurgerIcon color={mode ? "#fff" : "#646B88"} />
//           </div>
//         ) : (
//           <div
//             onClick={onClick}
//             className={`${styles.logo_img} ${mode ? styles.dark : ""}`}
//           >
//             {branding.favicon && (
//               <img
//                 src={branding.favicon}
//                 alt="Company Logo"
//                 style={{
//                   filter: !mode ? "brightness(0) saturate(100%)" : "none",
//                 }}
//               />
//             )}
//           </div>
//         )}
//       </div>

//       {/* Menu list — no gap, no padding, stretch full width */}
//       <div
//         className={styles.menuItem_div_con}
//         style={{ gap: 0, padding: "4px 0", alignItems: "stretch" }}
//       >
//         {/* ── Top standalones: DASHBOARD, ASK AI */}
//         {standaloneItems
//           .filter((item) =>
//             ["/dashboard", "/ai",].includes(getBaseRoute(item.path)),
//           )
//           .map((item, i) => renderStandaloneItem(item, i))}

//         {/* ── Groups */}
//         {MENU_GROUPS.map((group) => {
//           const groupItems = getGroupItems(group.paths);
//           if (groupItems.length === 0 && group.paths.length > 0) return null;

//           const isOpen = openGroup === group.label;
//           const isGroupActive = groupItems.some(
//             (item) => getBaseRoute(pathname) === getBaseRoute(item.path),
//           );
//           const GroupIcon = IconMap[group.iconKey];
//           const isHovered = hoveredGroup === group.label;

//           const headerStyle = isClosed
//             ? {
//                 ...ROW,
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 padding: "10px 4px",
//                 fontSize: "10px",
//                 gap: "2px",
//                 cursor: "default",
//                 backgroundColor: isOpen
//                   ? C.groupOpenBg
//                   : isHovered
//                     ? C.itemHover
//                     : C.itemBg,
//               }
//             : {
//                 ...ROW,
//                 backgroundColor: isOpen
//                   ? C.groupOpenBg
//                   : isHovered
//                     ? C.itemHover
//                     : C.itemBg,
//               };

//           return (
//             <div key={group.label} style={{ width: "100%" }}>
//               {/* Group header */}
//               <div
//                 style={headerStyle}
//                 onClick={() => !isClosed && toggleGroup(group.label)}
//                 onMouseEnter={() => setHoveredGroup(group.label)}
//                 onMouseLeave={() => setHoveredGroup(null)}
//               >
//                 {GroupIcon && (
//                   <GroupIcon
//                     css={styles.iconImage}
//                     color={isOpen || isGroupActive ? C.textGroupOpen : C.text}
//                   />
//                 )}
//                 {!isClosed && (
//                   <>
//                     <span
//                       style={{
//                         flex: 1,
//                         color: isOpen ? C.textGroupOpen : C.text,
//                         fontWeight: isOpen ? 600 : 500,
//                       }}
//                     >
//                       {group.label}
//                     </span>
//                     <ChevronIcon
//                       open={isOpen}
//                       color={isOpen ? C.textGroupOpen : C.text}
//                     />
//                   </>
//                 )}
//               </div>

//               {/* Sub-items with smooth slide */}
//               {!isClosed && (
//                 <div
//                   style={{
//                     width: "100%",
//                     overflow: "hidden",
//                     maxHeight: isOpen ? `${groupItems.length * 44}px` : "0px",
//                     transition: "max-height 0.22s ease",
//                     backgroundColor: C.subAreaBg,
//                     position: "relative",
//                   }}
//                 >
//                   {groupItems.map((item, i) =>
//                     renderSubItem(item, i, i === groupItems.length - 1),
//                   )}
//                 </div>
//               )}
//             </div>
//           );
//         })}

//         {/* ── Bottom standalones: CHAT, SETTINGS */}
//         {standaloneItems
//           .filter((item) =>
//             ["/whatsappchats", "/settings"].includes(getBaseRoute(item.path)),
//           )
//           .map((item, i) => renderStandaloneItem(item, i))}
//       </div>
//     </React.Fragment>
//   );
// };

// export default AdminMenu;

// import React, { useState, useEffect, useCallback } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { HamBurgerIcon } from "../components/icons/Icon";
// import { Drag } from "../components/icons/Icon2";
// import styles from "./Menus.module.css";
// import { useAuth } from "../components/context/Auth";
// import useWindowWidth from "../components/updatedComponents/Hooks/WidthSize";
// import { useDispatch, useSelector } from "react-redux";
// import { resetcampaignDashbord } from "../store/slices/campaign/CampaignDashbord";
// import { resetTemplatesFilter } from "../store/slices/campaign/TemplatesSlice";
// import { resetSearchDealerData } from "../store/slices/dealer/DealerSlice";
// import { resetProductFilter } from "../store/slices/product/ProductSlice";
// import { resetAllFilters } from "../store/slices/delivery/DeliverySlice";
// import { resetAllFilters as resetMangerFilters } from "../store/slices/managers/ManagersSlice";
// import { resetAllFilters as resetInvoicesFilters } from "../store/slices/invoices/InvoicesSlice";
// import { resetAppsFilter } from "../store/slices/apps/AppsSlice";
// import {
//   resetItemSarch,
//   resetProductSarch,
// } from "../store/slices/inventory/InventorySlice";
// import { IconMap } from "../exports";
// import { useBranding } from "../components/context/BrandingContext";

// // ─── Constants ────────────────────────────────────────────────────────────────

// const MENU_GROUPS = [
//   {
//     label: "SALES",
//     iconKey: "SideBarOrdersIcon",
//     paths: ["/marketing", "/dealers", "/orders", "/complaints"],
//   },
//   {
//     label: "STOCK",
//     iconKey: "SideBarProductIcon",
//     paths: ["/products", "/inventory", "/warehouses", "/deleteoredit"],
//   },
//   {
//     label: "DISPATCH",
//     iconKey: "SideBarDispatchIcon",
//     paths: ["/packingorder", "/dispatch", "/invoices", "/delivery"],
//   },
//   {
//     label: "ACCOUNTS",
//     iconKey: "SideBarReceiptIcon",
//     paths: ["/recipts", "/transactions", "/refunds"],
//   },
//   {
//     label: "MARKETING",
//     iconKey: "SideBarMarketingIcon",
//     paths: ["/campaign", "/greetings", "/createnotification"],
//   },
//   {
//     label: "TEAM",
//     iconKey: "SideBarManagerIcon",
//     paths: ["/managers", "/jobs", "/applicants"],
//   },
//   {
//     label: "UTILITIES",
//     iconKey: "AppsIcon",
//     paths: ["/apps", "/printers", "/energy"],
//   },
// ];

// // Paths that sit ABOVE all groups in the sidebar
// const TOP_PATHS = ["/dashboard", "/ai", "/whatsappchats", "/production"];
// // Paths that sit BELOW all groups
// const BOTTOM_PATHS = ["/settings"];

// // All paths that belong to a group
// const ALL_GROUP_PATHS = MENU_GROUPS.flatMap((g) => g.paths);

// // ─── Pure helpers (defined OUTSIDE component so they are hoisted and stable) ──

// const getBaseRoute = (url) => {
//   if (!url) return url;
//   const i = url.indexOf("/", 1);
//   return i === -1 ? url : url.slice(0, i);
// };

// const getActiveGroup = (pathname) => {
//   const base = getBaseRoute(pathname);
//   const match = MENU_GROUPS.find((g) => g.paths.includes(base));
//   return match ? match.label : null;
// };

// const resolveMenuItems = (menuItems, designation) => {
//   const storageKey = `updatedMenuItems_${designation?.[0] || "default"}`;
//   const raw = localStorage.getItem(storageKey);
//   if (raw) {
//     try {
//       const parsed = JSON.parse(raw).map((item) => ({
//         ...item,
//         Icon: IconMap[item.Icon] || null,
//       }));

//       const masterPaths = new Set(menuItems.map((m) => m.path));
//       const valid = parsed.every((item) => masterPaths.has(item.path));
//       if (valid) return parsed;
//       localStorage.removeItem(storageKey); // stale — clear it
//     } catch (_) {
//       localStorage.removeItem(storageKey);
//     }
//   }
//   return [...menuItems];
// };

// // ─── Shared base row style ────────────────────────────────────────────────────

// const ROW_BASE = {
//   width: "100%",
//   boxSizing: "border-box",
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   gap: "10px",
//   fontSize: "12px",
//   fontWeight: 500,
//   lineHeight: "18px",
//   cursor: "pointer",
//   transition: "background-color 0.15s",
//   userSelect: "none",
// };

// // ─── ChevronIcon ──────────────────────────────────────────────────────────────

// const ChevronIcon = ({ open, color }) => (
//   <svg
//     width="12"
//     height="12"
//     viewBox="0 0 12 12"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//     style={{
//       transition: "transform 0.2s ease",
//       transform: open ? "rotate(180deg)" : "rotate(0deg)",
//       flexShrink: 0,
//     }}
//   >
//     <path
//       d="M2 4L6 8L10 4"
//       stroke={color || "#646B88"}
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// // ─── AdminMenu ────────────────────────────────────────────────────────────────

// const AdminMenu = ({ onClick, isClosed, menuItems }) => {
//   const navigate = useNavigate();
//   const { designation, mode } = useAuth();
//   const { dragMode } = useSelector((s) => s.layout);
//   const { pathname } = useLocation();
//   const dispatch = useDispatch();
//   const { branding } = useBranding();
//   const windowWidth = useWindowWidth();

//   const isMobile = windowWidth <= 768;
//   // On mobile always render in expanded (open) mode
//   const effectivelyClosed = isMobile ? false : isClosed;

//   // ── Menu items ──────────────────────────────────────────────────────────────
//   // Initialised synchronously from resolveMenuItems so first paint is correct.
//   const [updatedMenuItems, setUpdatedMenuItems] = useState(() =>
//     resolveMenuItems(menuItems, designation),
//   );

//   // Re-sync when designation or menuItems prop changes
//   useEffect(() => {
//     setUpdatedMenuItems(resolveMenuItems(menuItems, designation));
//   }, [designation, menuItems]);

//   // ── Open group ──────────────────────────────────────────────────────────────

//   const [openGroup, setOpenGroup] = useState(() => getActiveGroup(pathname));

//   useEffect(() => {
//     const active = getActiveGroup(pathname);
//     setOpenGroup(active); // null for standalone, label for group
//   }, [pathname]);

//   const [hoveredPath, setHoveredPath] = useState(null);
//   const [hoveredGroup, setHoveredGroup] = useState(null);
//   const [draggedIndex, setDraggedIndex] = useState(null);

//   // ── Drag-and-drop (manager home screen swap) ────────────────────────────────
//   const handleDragStart = (index) => setDraggedIndex(index);

//   const handleDrop = (dropIndex) => {
//     if (draggedIndex === null) return;
//     if (designation.includes("superadmin") || designation.length === 1) {
//       setDraggedIndex(null);
//       return;
//     }
//     if (dropIndex === 0 && draggedIndex !== 0) {
//       const items = [...updatedMenuItems];
//       const droppedItem = { ...items[draggedIndex] };
//       const oldDashboard = { ...items[0] };
//       items[0] = { ...droppedItem, label: "DASHBOARD" };
//       const orig = menuItems.find((m) => m.path === oldDashboard.path);
//       items[draggedIndex] = orig ? { ...orig } : { ...oldDashboard };
//       const storageKey = `updatedMenuItems_${designation?.[0] || "default"}`;
//       localStorage.setItem("dashboardRoute", droppedItem.path);
//       localStorage.setItem(
//         storageKey,
//         JSON.stringify(
//           items.map((item) => ({
//             ...item,
//             Icon: item.Icon?.name || item.IconName || null,
//           })),
//         ),
//       );
//       setUpdatedMenuItems(items);
//     }
//     setDraggedIndex(null);
//   };

//   // ── Navigation ──────────────────────────────────────────────────────────────
//   const handleMenuClick = (path) => {
//     if (dragMode) return;

//     const base = getBaseRoute(path);
//     if (!ALL_GROUP_PATHS.includes(base)) {
//       setOpenGroup(null);
//     }

//     if (path !== "/dealers") dispatch(resetSearchDealerData());
//     if (path !== "/campaign") {
//       dispatch(resetcampaignDashbord());
//       dispatch(resetTemplatesFilter());
//     }
//     if (path !== "/products") dispatch(resetProductFilter());
//     if (path !== "/delivery") dispatch(resetAllFilters());
//     if (path !== "/managers") dispatch(resetMangerFilters());
//     if (path !== "/apps") dispatch(resetAppsFilter());
//     if (path !== "/invoices") dispatch(resetInvoicesFilters());
//     if (path !== "/inventory") {
//       dispatch(resetProductSarch());
//       dispatch(resetItemSarch());
//     }

//     navigate(path);

//     // Close sidebar on mobile after navigation
//     if (isMobile && !isClosed && onClick) onClick();
//   };

//   const toggleGroup = (label) =>
//     setOpenGroup((prev) => (prev === label ? null : label));

//   // ── Item bucketing ──────────────────────────────────────────────────────────
//   const nonGroupItems = updatedMenuItems.filter(
//     (item) => !ALL_GROUP_PATHS.includes(getBaseRoute(item.path)),
//   );
//   const topItems = nonGroupItems.filter((item) =>
//     TOP_PATHS.includes(getBaseRoute(item.path)),
//   );
//   const bottomItems = nonGroupItems.filter((item) =>
//     BOTTOM_PATHS.includes(getBaseRoute(item.path)),
//   );
//   const middleItems = nonGroupItems.filter((item) => {
//     const base = getBaseRoute(item.path);
//     return !TOP_PATHS.includes(base) && !BOTTOM_PATHS.includes(base);
//   });

//   const getGroupItems = (groupPaths) =>
//     updatedMenuItems.filter((item) =>
//       groupPaths.includes(getBaseRoute(item.path)),
//     );

//   // ── Theme ───────────────────────────────────────────────────────────────────
//   const C = mode
//     ? {
//         itemBg: "#2C2E33",
//         itemHover: "#35383f",
//         itemActive: "#232529",
//         groupOpenBg: "#232529",
//         subAreaBg: "#25272c",
//         subHover: "#2e3138",
//         subActive: "#2e3040",
//         text: "#9ea3b0",
//         textActive: "#ffffff",
//         textGroupOpen: "#ffffff",
//         activeBorder: "#7c8cf8",
//       }
//     : {
//         itemBg: "#ffffff",
//         itemHover: "#f5f6fa",
//         itemActive: "#eef0f8",
//         groupOpenBg: "#eef0f8",
//         subAreaBg: "#f5f6fa",
//         subHover: "#eaecf5",
//         subActive: "#e2e5f5",
//         text: "#646B88",
//         textActive: "#1a1a2e",
//         textGroupOpen: "#1a1a2e",
//         activeBorder: "#5b6af0",
//       };

//   // ── Renderers ───────────────────────────────────────────────────────────────

//   const renderStandaloneItem = (item, index) => {
//     const { label, path, Icon, IconName } = item;
//     const FinalIcon = Icon || IconMap[IconName];
//     const isActive = getBaseRoute(pathname) === getBaseRoute(path);
//     const isHovered = hoveredPath === path;

//     const closedStyle = {
//       ...ROW_BASE,
//       flexDirection: "column",
//       justifyContent: "center",
//       padding: "10px 4px",
//       fontSize: "10px",
//       gap: "2px",
//       backgroundColor: isActive
//         ? C.itemActive
//         : isHovered
//           ? C.itemHover
//           : C.itemBg,
//     };

//     const openStyle = {
//       ...ROW_BASE,
//       padding: "10px 14px 10px 11px", // 11px left = 14px − 3px border
//       // borderLeft: `3px solid ${isActive ? C.activeBorder : "transparent"}`,
//       backgroundColor: isActive
//         ? C.itemActive
//         : isHovered
//           ? C.itemHover
//           : C.itemBg,
//     };

//     return (
//       <div
//         key={path}
//         style={effectivelyClosed ? closedStyle : openStyle}
//         onClick={() => handleMenuClick(path)}
//         onMouseEnter={() => setHoveredPath(path)}
//         onMouseLeave={() => setHoveredPath(null)}
//         draggable={dragMode}
//         onDragStart={() => handleDragStart(index)}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={() => handleDrop(index)}
//       >
//         {dragMode && (
//           <div className={styles.dragHandle}>
//             <Drag color={mode ? "#fff" : "#000"} />
//           </div>
//         )}
//         {FinalIcon && (
//           <FinalIcon
//             css={styles.iconImage}
//             color={isActive ? C.textActive : C.text}
//           />
//         )}
//         {!effectivelyClosed && (
//           <span
//             style={{
//               color: isActive ? C.textActive : C.text,
//               fontWeight: isActive ? 600 : 500,
//               flex: 1,
//             }}
//           >
//             {label}
//           </span>
//         )}
//       </div>
//     );
//   };

//   const renderSubItem = (item, index, isLast) => {
//     const { label, path, Icon, IconName } = item;
//     const FinalIcon = Icon || IconMap[IconName];
//     const isActive = getBaseRoute(pathname) === getBaseRoute(path);
//     const isHovered = hoveredPath === path;

//     const lineColor = mode ? "#3e4150" : "#d0d3e8";
//     const dotColor = isActive ? C.activeBorder : mode ? "#555870" : "#b0b4d0";

//     return (
//       <div
//         key={path}
//         style={{
//           width: "100%",
//           boxSizing: "border-box",
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "center",

//           // borderLeft: `3px solid ${isActive ? C.activeBorder : "transparent"}`,
//           backgroundColor: isActive
//             ? C.subActive
//             : isHovered
//               ? C.subHover
//               : C.subAreaBg,
//           cursor: "pointer",
//           transition: "background-color 0.15s",
//           position: "relative",
//         }}
//         onClick={() => handleMenuClick(path)}
//         onMouseEnter={() => setHoveredPath(path)}
//         onMouseLeave={() => setHoveredPath(null)}
//         draggable={dragMode}
//         onDragStart={() => handleDragStart(index)}
//         onDragOver={(e) => e.preventDefault()}
//         onDrop={() => handleDrop(index)}
//       >
//         {dragMode && (
//           <div className={styles.dragHandle}>
//             <Drag color={mode ? "#fff" : "#000"} />
//           </div>
//         )}

//         {/* Tree connector lines */}
//         <div
//           style={{
//             position: "relative",
//             width: "35px", // slightly narrower to account for 3px border
//             flexShrink: 0,
//             alignSelf: "stretch",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "flex-end",
//           }}
//         >
//           {/* Vertical line */}
//           <div
//             style={{
//               position: "absolute",
//               left: "15px",
//               top: 0,
//               bottom: isLast ? "50%" : 0,
//               width: "1.5px",
//               backgroundColor: lineColor,
//             }}
//           />
//           {/* Horizontal branch */}
//           <div
//             style={{
//               position: "absolute",
//               left: "15px",
//               top: "50%",
//               width: "12px",
//               height: "1.5px",
//               backgroundColor: lineColor,
//             }}
//           />
//           {/* Junction dot */}
//           <div
//             style={{
//               position: "absolute",
//               left: "22px",
//               top: "50%",
//               transform: "translateY(-50%)",
//               width: "6px",
//               height: "6px",
//               borderRadius: "50%",
//               backgroundColor: dotColor,
//               flexShrink: 0,
//               zIndex: 1,
//             }}
//           />
//         </div>

//         {/* Icon + label */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             gap: "8px",
//             padding: "9px 10px 9px 2px",
//             flex: 1,
//             minWidth: 0,
//           }}
//         >
//           {FinalIcon && (
//             <FinalIcon
//               css={styles.iconImage}
//               color={isActive ? C.textActive : C.text}
//             />
//           )}
//           <span
//             style={{
//               color: isActive ? C.textActive : C.text,
//               fontWeight: isActive ? 600 : 400,
//               fontSize: "11px",
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//             }}
//           >
//             {label}
//           </span>
//         </div>
//       </div>
//     );
//   };

//   // ── Render ──────────────────────────────────────────────────────────────────
//   return (
//     <React.Fragment>
//       {/* Logo / hamburger */}
//       <div
//         className={`${styles.admin_menu_logo} ${mode ? styles.admin_menu_logo_dark : ""}`}
//       >
//         {effectivelyClosed ? (
//           <div onClick={onClick}>
//             <HamBurgerIcon color={mode ? "#fff" : "#646B88"} />
//           </div>
//         ) : (
//           <div
//             onClick={onClick}
//             className={`${styles.logo_img} ${mode ? styles.dark : ""}`}
//           >
//             {branding.favicon && (
//               <img
//                 src={branding.favicon}
//                 alt="Company Logo"
//                 style={{
//                   filter: !mode ? "brightness(0) saturate(100%)" : "none",
//                 }}
//               />
//             )}
//           </div>
//         )}
//       </div>

//       {/* Menu list */}
//       <div
//         className={styles.menuItem_div_con}
//         style={{ gap: 0, padding: "4px 0", alignItems: "stretch" }}
//       >
//         {/* TOP: Dashboard, AskAI, Chat, Production */}
//         {topItems.map((item, i) => renderStandaloneItem(item, i))}

//         {/* MIDDLE: any non-group item not in TOP/BOTTOM (manager custom screens) */}
//         {middleItems.map((item, i) => renderStandaloneItem(item, i))}

//         {/* GROUPS */}
//         {MENU_GROUPS.map((group) => {
//           const groupItems = getGroupItems(group.paths);
//           // Skip group entirely if this role has no items in it
//           if (groupItems.length === 0) return null;

//           const isOpen = openGroup === group.label;
//           const isGroupActive = groupItems.some(
//             (item) => getBaseRoute(pathname) === getBaseRoute(item.path),
//           );
//           const GroupIcon = IconMap[group.iconKey];
//           const isHovered = hoveredGroup === group.label;

//           const closedHeaderStyle = {
//             ...ROW_BASE,
//             flexDirection: "column",
//             justifyContent: "center",
//             padding: "10px 4px",
//             fontSize: "10px",
//             gap: "2px",
//             cursor: "default",
//             backgroundColor: isOpen
//               ? C.groupOpenBg
//               : isHovered
//                 ? C.itemHover
//                 : C.itemBg,
//           };

//           const openHeaderStyle = {
//             ...ROW_BASE,

//             padding: "10px 14px 10px 11px",
//             // borderLeft: `3px solid ${isGroupActive ? C.activeBorder : "transparent"}`,
//             backgroundColor: isOpen
//               ? C.groupOpenBg
//               : isHovered
//                 ? C.itemHover
//                 : C.itemBg,
//           };

//           return (
//             <div
//               key={group.label}
//               style={{ width: "100%" }}
//               onMouseEnter={() =>
//                 !effectivelyClosed && setOpenGroup(group.label)
//               }
//               onMouseLeave={() => !effectivelyClosed && setOpenGroup(null)}
//             >
//               {/* Group header row */}
//               <div
//                 style={effectivelyClosed ? closedHeaderStyle : openHeaderStyle}
//                 onClick={() => !effectivelyClosed && toggleGroup(group.label)}
//                 onMouseEnter={() => setHoveredGroup(group.label)}
//                 onMouseLeave={() => setHoveredGroup(null)}
//               >
//                 {GroupIcon && (
//                   <GroupIcon
//                     css={styles.iconImage}
//                     color={isOpen || isGroupActive ? C.textGroupOpen : C.text}
//                   />
//                 )}
//                 {!effectivelyClosed && (
//                   <>
//                     <span
//                       style={{
//                         flex: 1,
//                         color:
//                           isOpen || isGroupActive ? C.textGroupOpen : C.text,
//                         fontWeight: isOpen || isGroupActive ? 600 : 500,
//                       }}
//                     >
//                       {group.label}
//                     </span>
//                     <ChevronIcon
//                       open={isOpen}
//                       color={isOpen || isGroupActive ? C.textGroupOpen : C.text}
//                     />
//                   </>
//                 )}
//               </div>

//               {/* Animated sub-item list */}
//               {!effectivelyClosed && (
//                 <div
//                   style={{
//                     width: "100%",
//                     overflow: "hidden",
//                     maxHeight: isOpen ? `${groupItems.length * 44}px` : "0px",
//                     transition: "max-height 0.22s ease",
//                     backgroundColor: C.subAreaBg,
//                   }}
//                 >
//                   {groupItems.map((item, i) =>
//                     renderSubItem(item, i, i === groupItems.length - 1),
//                   )}
//                 </div>
//               )}
//             </div>
//           );
//         })}

//         {/* BOTTOM: Settings */}
//         {bottomItems.map((item, i) => renderStandaloneItem(item, i))}
//       </div>
//     </React.Fragment>
//   );
// };

// export default AdminMenu;
